import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const PropertyLinked = React.lazy(
  () => import('components/Property/Linked/Linked'),
);

function ScreensPropertyLinked(params: Readonly<RoutePrivateProps>) {
  return (
    <BaseLayout>
      <DocumentTitle>Property Management</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <PropertyLinked
          id={parseInt(params.id as string, 10)}
          key={params.id}
        />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensPropertyLinked;
